/* SOLEPLIER - Protection checkout buttons (Nov 2, 2026; v3 info modal + hidden ShipTection widget; v4 bubbles hidden while drawer/popup open; v5 protection line hidden from cart display). See snippets/protection-checkout-buttons.liquid */
(function () {
    if (window.__spProtectionButtons) return;
    window.__spProtectionButtons = true;

    var PRODUCT_ID = 7160999018554; // ShipTection "Package Protection (Recommended)" product; overridden by data-sp-protection-product-id
    var SHOP = (window.Shopify && Shopify.shop) || 'soleplier.myshopify.com';
    var CHECKOUT_URL = '/checkout';
    var DECLINED_COOKIE = 'shiptection-declined-insurance'; // the cookie ShipTection's own cart script checks before auto-adding
    var busy = false;

    // Styles (injected so they work in the cart page and the cloned cart drawer)
    var css = "\n  .sp-protect-decline {\n    display: block;\n    width: 100%;\n    margin-top: 10px;\n    text-align: center;\n    font-size: 12px;\n    line-height: 1.4;\n    text-decoration: underline;\n    opacity: 0.75;\n    cursor: pointer;\n  }\n  .sp-protect-decline:hover { opacity: 1; }\n  .sp-protect-btn.is-loading,\n  .sp-protect-decline.is-loading { opacity: 0.6; pointer-events: none; }\n  /* Protection line: no quantity controls (it should always be 1) */\n  .cart__item--protection [data-quantity-holder],\n  .cart__item--protection popout-select { display: none !important; }\n\n  /* One-line button label (wrap fix, Nov 2) */\n  .sp-protect-btn { white-space: nowrap; letter-spacing: 0.06em; }\n  .sp-protect-btn .sp-protect-btn__label { white-space: nowrap; }\n  /* Drawer button with total: label on line 1, total on a smaller line 2 */\n  .sp-protect-btn.sp-protect-btn--total {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 2px;\n    padding-top: 9px;\n    padding-bottom: 9px;\n    line-height: 1.2;\n  }\n  .sp-protect-btn--total .cart__total__money {\n    display: block;\n    font-size: 0.8em;\n    letter-spacing: 0.04em;\n    line-height: 1.2;\n    opacity: 0.85;\n    white-space: nowrap;\n  }\n  .sp-protect-btn--total .cart__total__money::before { content: none; margin: 0; }\n  @media only screen and (max-width: 359px) {\n    .sp-protect-btn { font-size: 13px; letter-spacing: 0.04em; padding-left: 12px; padding-right: 12px; }\n  }\n\n  /* v3: hide the ShipTection widget box in the cart (visual only; its script keeps running) */\n  #cart-drawer .shiptection-widget,\n  .cart-drawer .shiptection-widget,\n  [data-cart-page] .shiptection-widget,\n  .cart .shiptection-widget { display: none !important; }\n\n  /* v3: decline link + info button row */\n  .sp-protect-decline-row { display: flex; align-items: center; justify-content: center; gap: 6px; width: 100%; margin-top: 10px; }\n  .sp-protect-decline-row .sp-protect-decline { display: inline; width: auto; margin-top: 0; }\n  .sp-protect-info {\n    display: inline-flex; align-items: center; justify-content: center;\n    width: 24px; height: 24px; padding: 0; margin: 0;\n    border: 0; background: transparent; color: inherit; cursor: pointer;\n    opacity: 0.75; border-radius: 50%;\n  }\n  .sp-protect-info:hover, .sp-protect-info:focus-visible { opacity: 1; }\n  .sp-protect-info:focus-visible { outline: 2px solid currentColor; outline-offset: 1px; }\n  .sp-protect-info svg { width: 16px; height: 16px; display: block; }\n\n  /* v3: protection info / decline modal */\n  .sp-pmodal { position: fixed; inset: 0; z-index: 2147483000; display: flex; align-items: center; justify-content: center; padding: 16px; }\n  .sp-pmodal[hidden] { display: none !important; }\n  .sp-pmodal__backdrop { position: absolute; inset: 0; background: rgba(0, 0, 0, 0.55); }\n  .sp-pmodal__dialog {\n    position: relative; width: 100%; max-width: 420px; max-height: calc(100vh - 32px); overflow: auto;\n    background: var(--bg, #fff); color: var(--text, #000);\n    border-radius: var(--radius, 12px); box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n    padding: 32px 24px 22px; text-align: center; font-family: inherit;\n  }\n  .sp-pmodal__dialog:focus { outline: none; }\n  .sp-pmodal__x {\n    position: absolute; top: 8px; right: 8px; width: 40px; height: 40px; padding: 0;\n    display: inline-flex; align-items: center; justify-content: center;\n    background: transparent; border: 0; color: inherit; cursor: pointer;\n  }\n  .sp-pmodal__x svg { width: 18px; height: 18px; }\n  .sp-pmodal__x:focus-visible, .sp-pmodal__secondary:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }\n  .sp-pmodal__icon { display: block; width: 36px; height: 36px; margin: 0 auto 10px; }\n  .sp-pmodal__title { margin: 0 0 10px; font-size: 20px; line-height: 1.25; font-weight: 700; }\n  .sp-pmodal__text { margin: 0 0 8px; font-size: 14px; line-height: 1.5; opacity: 0.85; }\n  .sp-pmodal__price { margin: 0 0 4px; font-size: 13px; line-height: 1.4; font-weight: 600; }\n  .sp-pmodal__price[hidden] { display: none; }\n  .sp-pmodal__actions { display: flex; flex-direction: column; align-items: stretch; gap: 12px; margin-top: 18px; }\n  .sp-pmodal__primary { width: 100%; white-space: nowrap; }\n  .sp-pmodal__secondary {\n    align-self: center; background: transparent; border: 0; padding: 4px 6px; color: inherit; cursor: pointer;\n    font-size: 13px; text-decoration: underline; opacity: 0.8; font-family: inherit;\n  }\n  .sp-pmodal__secondary:hover { opacity: 1; }\n  .sp-pmodal .is-loading { opacity: 0.6; pointer-events: none; }\n  html.sp-pmodal-open, html.sp-pmodal-open body { overflow: hidden; }\n\n  /* v4: tuck away the floating Smile.io \"Rewards\" and Richpanel \"Chat with us\" bubbles\n     (Nov 3: plus the Shopify Inbox \"Message us\" bubble, <shopify-chat>) (and the search\n     back-to-top button) while the cart drawer or the protection popup is open, so they cannot cover\n     the checkout buttons, the \"Checkout without protection\" link or the (i) button. They come back on close. */\n  #smile-ui-lite-container,\n  .richpanel-micro,\n  shopify-chat,\n  .usf-goto-top { transition: opacity 0.2s ease, visibility 0.2s ease; }\n  body.js-drawer-open-cart #smile-ui-lite-container,\n  body.js-drawer-open-cart .richpanel-micro,\n  body.js-drawer-open-cart shopify-chat,\n  body.js-drawer-open-cart .usf-goto-top,\n  html.sp-pmodal-open #smile-ui-lite-container,\n  html.sp-pmodal-open .richpanel-micro,\n  html.sp-pmodal-open shopify-chat,\n  html.sp-pmodal-open .usf-goto-top {\n    opacity: 0 !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n  }\n\n  /* v5 (Nov 2): protection line hidden from the cart display only; it stays in the cart and shows at checkout */\n  .cart__item--protection { display: none !important; }\n";
    var styleEl = document.createElement('style');
    styleEl.setAttribute('data-sp-protection-styles', '');
    styleEl.textContent = css;
    (document.head || document.documentElement).appendChild(styleEl);

    function cookie(name, value, maxAgeSeconds) {
      document.cookie = name + '=' + value + ';path=/;max-age=' + maxAgeSeconds + ';SameSite=Lax';
    }
    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }
    function getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
    }
    function isProtection(item) { return Number(item.product_id) === Number(PRODUCT_ID); }
    function withTimeout(promise, ms) {
      return Promise.race([promise, new Promise(function (resolve) { setTimeout(function () { resolve(null); }, ms); })]);
    }
    // Same price quote ShipTection's own script uses: returns the right protection variant for this cart value
    function quote(cart) {
      var body = {
        items: cart.items.map(function (i) { return { product_id: i.product_id, price: i.price, quantity: i.quantity }; }),
        shop: SHOP,
        currency: cart.currency || 'USD'
      };
      return withTimeout(
        fetch('https://api.shiptection.com/quote', {
          method: 'POST',
          cache: 'no-store',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).catch(function () { return null; }),
        4000
      );
    }
    function termsBlocked(el) {
      var root = el.closest('form') || document;
      var terms = root.querySelector('[data-cart-acceptance-checkbox]');
      return terms && !terms.checked;
    }
    function go() { window.location.href = CHECKOUT_URL; }

    async function checkoutWithProtection() {
      var cart = await getCart();
      var protectionLines = cart.items.filter(isProtection);
      var hasMerch = cart.items.some(function (i) { return !isProtection(i); });
      if (!hasMerch) return go();

      // Shopper chose protection: clear any earlier "declined" choice
      cookie(DECLINED_COOKIE, '', 0);

      var q = await quote(cart);
      if (!q || !q.id || q.add_shiptection === false) {
        // Quote unavailable: keep whatever protection is already in the cart and continue
        if (cart.attributes && cart.attributes.__st_declined) await postJSON('/cart/update.js', { attributes: { __st_declined: '' } });
        return go();
      }

      var alreadyRight = protectionLines.length === 1 &&
        Number(protectionLines[0].variant_id) === Number(q.id) &&
        protectionLines[0].quantity === 1;

      if (!alreadyRight) {
        // Remove any wrong-priced or duplicate protection lines first
        for (var i = 0; i < protectionLines.length; i++) {
          await postJSON('/cart/change.js', { id: protectionLines[i].key, quantity: 0 });
        }
        await postJSON('/cart/add.js', { items: [{ id: Number(q.id), quantity: 1 }] });
      }
      await postJSON('/cart/update.js', { attributes: { __st_declined: '' } });
      go();
    }

    async function checkoutWithoutProtection() {
      // Set ShipTection's own "declined" cookie first so its script does not put the protection back
      cookie(DECLINED_COOKIE, 'true', 2 * 60 * 60);
      var cart = await getCart();
      var protectionLines = cart.items.filter(isProtection);
      for (var i = 0; i < protectionLines.length; i++) {
        await postJSON('/cart/change.js', { id: protectionLines[i].key, quantity: 0 });
      }
      // Same cart attribute ShipTection's own "Checkout without protection" link sets
      await postJSON('/cart/update.js', { attributes: { __st_declined: true } });
      go();
    }

    // ---------- v3: keep the cart drawer in sync with ShipTection's auto-add ----------
    // ShipTection adds/re-prices the protection line with its own /cart/update.js calls, and the theme does not
    // re-render the drawer afterwards. With the ShipTection box hidden, shoppers would otherwise see a stale
    // drawer (no protection line, old total). When a cart request finishes and the drawer total no longer
    // matches /cart.js, ask the theme to refresh the drawer (its own "theme:cart:refresh" event).
    var syncTimer = null;
    function drawerCents() {
      var el = document.querySelector('#cart-drawer [data-cart-total-price]');
      if (!el) return null;
      var digits = (el.textContent || '').replace(/[^0-9]/g, '');
      return digits ? Number(digits) : null;
    }
    function syncDrawer() {
      if (busy || drawerCents() === null) return;
      getCart().then(function (cart) {
        var lines = document.querySelectorAll('#cart-drawer .cart__item').length;
        var shown = drawerCents();
        if (busy || shown === null) return;
        if (shown !== cart.total_price || (cart.items.length && lines && lines !== cart.items.length)) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      }).catch(function () {});
    }
    if (window.PerformanceObserver) {
      try {
        new PerformanceObserver(function (list) {
          var hit = list.getEntries().some(function (e) { return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(e.name); });
          if (hit) { clearTimeout(syncTimer); syncTimer = setTimeout(syncDrawer, 600); }
        }).observe({ type: 'resource', buffered: true });
      } catch (e) {}
    }

    // ---------- v5: item count without the hidden protection line ----------
    // The theme rewrites "[data-cart-items-qty]" from the quantity fields of every line after each cart change.
    // The protection line is hidden, so take its quantity back out of the number shown.
    function fixItemCounts() {
      document.querySelectorAll('[data-cart-items-qty]').forEach(function (label) {
        var root = label.closest('cart-element') || label.closest('[data-cart-drawer], [data-cart-page]') || document;
        var total = 0, prot = 0;
        root.querySelectorAll('[data-quantity-field]').forEach(function (f) {
          var q = parseInt(f.value, 10) || 0;
          total += q;
          if (f.closest('.cart__item--protection')) prot += q;
        });
        if (!prot) return;
        var shown = parseInt((label.textContent || '').replace(/[^0-9]/g, ''), 10);
        if (shown !== total) return; // already corrected (or not a count we recognise)
        var n = total - prot;
        var one = ((window.theme && theme.strings && theme.strings.cart_items_one) || '{{ count }} item').split('}}')[1] || ' item';
        var many = ((window.theme && theme.strings && theme.strings.cart_items_many) || '{{ count }} items').split('}}')[1] || ' items';
        label.textContent = n === 1 ? n + ' ' + one.trim() : n + ' ' + many.trim();
      });
    }
    var countTimer = null;
    function scheduleCountFix() { clearTimeout(countTimer); countTimer = setTimeout(fixItemCounts, 50); }
    function watchCounts() {
      document.querySelectorAll('cart-element, [data-cart-drawer], [data-cart-page]').forEach(function (el) {
        if (el.__spCountWatch) return;
        el.__spCountWatch = true;
        new MutationObserver(scheduleCountFix).observe(el, { childList: true, subtree: true, characterData: true });
      });
      scheduleCountFix();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCounts); else watchCounts();

    // ---------- v3: info / decline modal ----------
    var TEXT = 'If shipping protection is declined, SOLEPLIER is not responsible for packages that are lost, stolen, or damaged in transit. Your order ships at your own risk.';
    var ICON_SHIELD = '<svg class="sp-pmodal__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
    var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    var modal = null, dialog = null, lastTrigger = null, swallowEscUp = false;

    function buildModal() {
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'sp-pmodal';
      modal.setAttribute('data-sp-pmodal', '');
      modal.hidden = true;
      modal.innerHTML =
        '<div class="sp-pmodal__backdrop" data-sp-pmodal-close></div>' +
        '<div class="sp-pmodal__dialog" role="dialog" aria-modal="true" aria-labelledby="sp-pmodal-title" aria-describedby="sp-pmodal-text" tabindex="-1">' +
          '<button type="button" class="sp-pmodal__x" data-sp-pmodal-close aria-label="Close">' + ICON_X + '</button>' +
          ICON_SHIELD +
          '<h2 class="sp-pmodal__title" id="sp-pmodal-title"></h2>' +
          '<p class="sp-pmodal__text" id="sp-pmodal-text"></p>' +
          '<p class="sp-pmodal__price" data-sp-pmodal-price hidden></p>' +
          '<div class="sp-pmodal__actions">' +
            '<button type="button" class="btn btn--solid btn--primary sp-pmodal__primary" data-sp-pmodal-action="with">Add protection &amp; checkout</button>' +
            '<button type="button" class="sp-pmodal__secondary" data-sp-pmodal-action="without">Continue without protection</button>' +
          '</div>' +
        '</div>';
      modal.querySelector('#sp-pmodal-text').textContent = TEXT;
      document.body.appendChild(modal);
      dialog = modal.querySelector('.sp-pmodal__dialog');
      return modal;
    }
    function isOpen() { return !!(modal && !modal.hidden); }
    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'), function (n) { return !n.disabled && n.offsetParent !== null; });
    }
    function money(n) { return '$' + Number(n).toFixed(2); }

    function openModal(mode, trigger) {
      buildModal();
      lastTrigger = trigger || document.activeElement;
      // Copy the theme's checkout button style onto the primary button when we can
      var themeBtn = (trigger && (trigger.closest('form') || document).querySelector('[data-sp-protection-checkout="with"]')) || document.querySelector('[data-sp-protection-checkout="with"]');
      var primary = modal.querySelector('[data-sp-pmodal-action="with"]');
      if (themeBtn) {
        var cls = themeBtn.className.split(/\s+/).filter(function (c) { return c && !/^(cart__checkout|sp-protect-btn--total|is-loading|btn--advanced)/.test(c); });
        primary.className = cls.join(' ') + ' sp-pmodal__primary';
      }
      modal.querySelector('#sp-pmodal-title').textContent = mode === 'info' ? 'About shipping protection' : 'Checkout without protection?';
      var priceEl = modal.querySelector('[data-sp-pmodal-price]');
      priceEl.hidden = true;
      modal.querySelectorAll('.is-loading').forEach(function (n) { n.classList.remove('is-loading'); n.removeAttribute('aria-busy'); });
      modal.hidden = false;
      document.documentElement.classList.add('sp-pmodal-open');
      setTimeout(function () { (mode === 'info' ? modal.querySelector('.sp-pmodal__x') : primary).focus(); }, 0);
      // Show this cart's protection price (same quote the button uses)
      getCart().then(function (cart) {
        if (!cart.items.some(function (i) { return !isProtection(i); })) return null;
        return quote(cart);
      }).then(function (q) {
        if (q && q.price && isOpen()) {
          priceEl.textContent = 'Protection for this order: ' + money(q.price);
          priceEl.hidden = false;
        }
      }).catch(function () {});
    }
    function closeModal() {
      if (!isOpen()) return;
      modal.hidden = true;
      document.documentElement.classList.remove('sp-pmodal-open');
      if (lastTrigger && document.contains(lastTrigger)) { try { lastTrigger.focus(); } catch (e) {} }
    }
    function run(action, el) {
      if (busy) return;
      busy = true;
      if (el) { el.classList.add('is-loading'); el.setAttribute('aria-busy', 'true'); }
      action().catch(function (err) {
        console.error('[SOLEPLIER protection buttons]', err);
        go(); // never block a sale because of a script error
      });
    }

    // Window capture: runs before the theme's drawer handlers (outside-click close, focus trap, Esc)
    window.addEventListener('click', function (event) {
      var t = event.target;
      if (isOpen() && modal.contains(t)) {
        event.stopPropagation();
        if (t.closest('[data-sp-pmodal-close]')) { event.preventDefault(); closeModal(); return; }
        var act = t.closest('[data-sp-pmodal-action]');
        if (act) {
          event.preventDefault();
          run(act.getAttribute('data-sp-pmodal-action') === 'without' ? checkoutWithoutProtection : checkoutWithProtection, act);
        }
        return;
      }
      var info = t.closest && t.closest('[data-sp-protection-info]');
      if (info) {
        event.preventDefault();
        event.stopPropagation();
        openModal('info', info);
        return;
      }
      var el = t.closest && t.closest('[data-sp-protection-checkout]');
      if (!el) return;
      var pidHolder = (el.closest('form') || document).querySelector('[data-sp-protection-product-id]');
      if (pidHolder && Number(pidHolder.getAttribute('data-sp-protection-product-id'))) PRODUCT_ID = Number(pidHolder.getAttribute('data-sp-protection-product-id'));
      if (termsBlocked(el)) return; // let the theme show its terms error
      event.preventDefault();
      event.stopPropagation();
      if (el.getAttribute('data-sp-protection-checkout') === 'without') { openModal('decline', el); return; }
      run(checkoutWithProtection, el);
    }, true);

    // The theme closes the cart drawer on any document mousedown outside it; clicks inside our modal must not count
    ['mousedown', 'pointerdown', 'touchstart'].forEach(function (type) {
      window.addEventListener(type, function (event) {
        if (isOpen() && modal.contains(event.target)) event.stopPropagation();
      }, { capture: true, passive: true });
    });

    window.addEventListener('keydown', function (event) {
      if (!isOpen()) return;
      if (event.key === 'Escape' || event.code === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        swallowEscUp = true;
        closeModal();
        return;
      }
      if (event.key === 'Tab') {
        event.stopPropagation();
        var f = focusables();
        if (!f.length) { event.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1];
        if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
        return;
      }
      if (modal.contains(event.target)) event.stopPropagation();
    }, true);
    window.addEventListener('keyup', function (event) {
      if ((event.key === 'Escape' || event.code === 'Escape') && (swallowEscUp || isOpen())) {
        // the cart drawer closes on Esc keyup; closing our modal must not close the drawer
        event.stopPropagation();
        swallowEscUp = false;
      }
    }, true);
    window.addEventListener('focusin', function (event) {
      if (!isOpen()) return;
      event.stopPropagation(); // keep the theme's drawer focus trap from pulling focus out of the modal
      if (!modal.contains(event.target)) { var f = focusables(); (f[0] || dialog).focus(); }
    }, true);
  })();
